import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { guacHttpClient } from "@/lib/http";
import { CompanyNote, CreateCompanyNoteRequest, HttpResponse } from "@/types";

export function useCreateCompanyNote() {
  const currentCompanyId = useCurrentCompanyId();

  const mutation = useMutation({
    mutationFn: async ({
      createCompanyNoteRequest,
    }: {
      createCompanyNoteRequest: CreateCompanyNoteRequest;
    }) => {
      const path = `companies/${currentCompanyId}/company-notes`;
      const res = await guacHttpClient.post<
        CompanyNote,
        HttpResponse<CompanyNote>,
        CreateCompanyNoteRequest
      >(path, createCompanyNoteRequest);

      return res.data;
    },
  });

  return mutation;
}
